module.exports = __webpack_public_path__ + "img/create-wallet-m.fae4f366.png";